import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'shared/store';

import App from './app/App';
import { AnalyticsIdentity, initAnalytics } from './app/analytics';
import './styles.css';

initAnalytics();

const container = document.getElementById('root');

if (!container) {
  throw new Error("Target container 'root' is not a DOM element.");
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AnalyticsIdentity />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
